<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
  <mat-label *ngIf="label() as label">{{ label }}</mat-label>
  <input
    type="text"
    placeholder="Kies"
    aria-label="Number"
    matInput
    [formControl]="formControl"
    (input)="setInputValue($event)"
    (focus)="setInputValue($event)"
    [matAutocomplete]="auto"
    (blur)="handleBlur()"
  />
  <mat-autocomplete
    requireSelection
    #auto="matAutocomplete"
    [displayWith]="displayWith()"
    [panelWidth]="_panelWidth()"
  >
    @for (item of items(); track item) {
      <mat-option [value]="item">
        <span class="!whitespace-pre">
          {{ displayWith() | apply: item }}
        </span>
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
